// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as CircleDefault } from '../../../assets/icons/default/shapes/circle.svg?react';
import { ReactComponent as CircleSolid } from '../../../assets/icons/solid/shapes/CIRCLE.svg?react';
import { createIcons } from '../../Icon';
const CircleIcon = /* @__PURE__ */ createIcons('Circle', {
    default: CircleDefault,
    solid: CircleSolid
});
CircleIcon.supportedTypes = ['default', 'solid'];
CircleIcon.category = 'shapes';
export default CircleIcon;
